import { RouteObject } from "react-router-dom";

export const FAQ_HOME_ROUTE = "faq/home";

export function inFaqHomeView(url: string) {
  return url.includes(FAQ_HOME_ROUTE);
}

export function inFaqBuilder(url: string) {
  return url.includes("faq/editor/");
}

export const faqRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "FAQ's" },
    path: "home",
    lazy: async () => {
      const { FaqContentPage } =
        await import("@redotech/redo-merchant-support-app/faq/faq-content-page");
      return { Component: FaqContentPage };
    },
  },
  {
    path: "editor/theme/collection/:collectionId",
    lazy: async () => {
      const { FaqThemeEditor } =
        await import("@redotech/redo-merchant-support-app/faq/faq-theme-editor");
      return { Component: FaqThemeEditor };
    },
  },
  {
    path: "editor/theme/article/:articleId",
    lazy: async () => {
      const { FaqThemeEditor } =
        await import("@redotech/redo-merchant-support-app/faq/faq-theme-editor");
      return { Component: FaqThemeEditor };
    },
  },
  {
    path: "editor/theme",
    lazy: async () => {
      const { FaqThemeEditor } =
        await import("@redotech/redo-merchant-support-app/faq/faq-theme-editor");
      return { Component: FaqThemeEditor };
    },
  },
  {
    path: "editor/:id",
    lazy: async () => {
      const { FaqBuilderWrapper } =
        await import("@redotech/redo-merchant-support-app/faq/faq-builder");
      return { Component: FaqBuilderWrapper };
    },
  },
];
